import { MetricBase, defaultMetricBase } from './metrics';

export interface PayrollByAdjuster {
    adjuster: string; 
    payrollAmt: number; 
}

export interface PayrollByMonth {
    order: number; 
    month: string; 
    amount: number; 
    advancedAmount: number; 
}

export interface PayrollDashboard {
    ytdActiveAdjusters: MetricBase<number>; 
    ytdPayrollAmt: MetricBase<number>; 
    ytdAdvancedAmt: MetricBase<number>; 
    fundsAwaitingPayout: MetricBase<number>; 
    topTenAdjusters: PayrollByAdjuster[]; 
    payrollByMonth: PayrollByMonth[]; 
}

export const defaultPayrollDashboard: PayrollDashboard = {
    ytdActiveAdjusters: defaultMetricBase, 
    ytdPayrollAmt: defaultMetricBase, 
    ytdAdvancedAmt: defaultMetricBase, 
    fundsAwaitingPayout: defaultMetricBase, 
    topTenAdjusters: [] as PayrollByAdjuster[],
    payrollByMonth: [] as PayrollByMonth[], 
}
